import React from "react";
import { CpdsButtonFloatingStyle, CpdsButtonLinkStyle, CpdsButtonPrimaryStyle, CpdsButtonSecondaryStyle, CpdsButtonStyle, CpdsButtonTertiaryStyle, CpdsButtonLinkPrimaryStyle,CpdsButtonLinkSecondaryStyle, CpdsButtonLinkTertiaryStyle, CpdsButtonLinkFloatingStyle } from "./styles/cpds-button-style";
import { CpdsButtonType } from "./typings";
import { checkValue } from "src/components/functions";

// Subcomponent utility function to get valid media queries
export const getButtonStyle = (type: CpdsButtonType) => {
  switch (type) {
    case 'Primary':
      return CpdsButtonPrimaryStyle;
    case 'Secondary':
      return CpdsButtonSecondaryStyle;
    case 'Tertiary':
      return CpdsButtonTertiaryStyle;
    case 'Floating':
      return CpdsButtonFloatingStyle;
    default:
      return CpdsButtonStyle;
  }
};

export const getLinkStyle = (type: CpdsButtonType) => {
  switch (type) {
    case 'Primary':
      return CpdsButtonLinkPrimaryStyle;
    case 'Secondary':
      return CpdsButtonLinkSecondaryStyle;
    case 'Tertiary':
      return CpdsButtonLinkTertiaryStyle;
    case 'Floating':
      return CpdsButtonLinkFloatingStyle;
    default:
      return CpdsButtonLinkStyle;
  }
};

export const getChildrens = (childrens: any) => {
  let childs = {leadingIcon: undefined, buttonText: undefined,trailingIcon: undefined};
  React.Children.forEach(childrens, (child: React.ComponentElement<any, any>, index) => {

    const isIcon = (child?.type?.name === 'CpdsIcon' || checkValue(child?.props?.name));
    
    if(typeof child === 'object' && isIcon && index === 0) {
      childs = {...childs, leadingIcon: child};
    }else if(typeof child === 'string' ){
      childs = {...childs, buttonText: child};
    }else if(typeof child === 'object' && isIcon){
      childs = {...childs, trailingIcon: child};
    }
  })

  return childs;
};